export default {
  FETCH_POST: 'FETCH_POST',
  FETCH_POST_SUCCESS: 'FETCH_POST_SUCCESS',
  FETCH_POST_FAILURE: 'FETCH_POST_FAILURE',

  FETCH_NEXT_POSTS: 'FETCH_NEXT_POSTS',
  FETCH_NEXT_POSTS_SUCCESS: 'FETCH_NEXT_POSTS_SUCCESS',
  FETCH_NEXT_POSTS_FAILURE: 'FETCH_NEXT_POSTS_FAILURE',

  FETCH_POPULAR_POSTS: 'FETCH_POPULAR_POSTS',
  FETCH_POPULAR_POSTS_SUCCESS: 'FETCH_POPULAR_POSTS_SUCCESS',
  FETCH_POPULAR_POSTS_FAILURE: 'FETCH_POPULAR_POSTS_FAILURE',

  FETCH_FEATURED_POSTS: 'FETCH_FEATURED_POSTS',
  FETCH_FEATURED_POSTS_SUCCESS: 'FETCH_FEATURED_POSTS_SUCCESS',
  FETCH_FEATURED_POSTS_FAILURE: 'FETCH_FEATURED_POSTS_FAILURE',

  DISMISS_POST_FEATURED_POST: 'DISMISS_POST_FEATURED_POST',
  DISMISS_POST_FEATURED_POST_SUCCESS: 'DISMISS_POST_FEATURED_POST_SUCCESS',
  DISMISS_POST_FEATURED_POST_FAILURE: 'DISMISS_POST_FEATURED_POST_FAILURE',

  FETCH_CATEGORIES: 'FETCH_CATEGORIES',
  FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_FAILURE: 'FETCH_CATEGORIES_FAILURE',

  FETCH_PINNED_POSTS: 'FETCH_PINNED_POSTS',
  FETCH_PINNED_POSTS_SUCCESS: 'FETCH_PINNED_POSTS_SUCCESS',
  FETCH_PINNED_POSTS_FAILURE: 'FETCH_PINNED_POSTS_FAILURE',

  FETCH_RELATED_PAST_POSTS: 'FETCH_RELATED_PAST_POSTS',
  FETCH_RELATED_PAST_POSTS_SUCCCESS: 'FETCH_RELATED_PAST_POSTS_SUCCCESS',
  FETCH_RELATED_PAST_POSTS_FAILURE: 'FETCH_RELATED_PAST_POSTS_FAILURE',

  UPDATE_POST_LOCK: 'UPDATE_POST_LOCK',
  UPDATE_POST_LOCK_SUCCESS: 'UPDATE_POST_LOCK_SUCCESS',
  UPDATE_POST_LOCK_FAILURE: 'UPDATE_POST_LOCK_FAILURE',

  UPDATE_POST_PIN: 'UPDATE_POST_PIN',
  UPDATE_POST_PIN_SUCCESS: 'UPDATE_POST_PIN_SUCCESS',
  UPDATE_POST_PIN_FAILURE: 'UPDATE_POST_PIN_FAILURE',

  DELETE_POST: 'DELETE_POST',
  DELETE_POST_SUCCESS: 'DELETE_POST_SUCCESS',
  DELETE_POST_FAILURE: 'DELETE_POST_FAILURE',

  FETCH_CURRENT_COMMUNITY_ROLES: 'FETCH_CURRENT_COMMUNITY_ROLES',
  FETCH_CURRENT_COMMUNITY_ROLES_SUCCESS: 'FETCH_CURRENT_COMMUNITY_ROLES_SUCCESS',
  FETCH_CURRENT_COMMUNITY_ROLES_FAILURE: 'FETCH_CURRENT_COMMUNITY_ROLES_FAILURE',

  ASSIGN_BADGES: 'ASSIGN_BADGES',
  ASSIGN_BADGES_SUCCESS: 'ASSIGN_BADGES_SUCCESS',
  ASSIGN_BADGES_FAILURE: 'ASSIGN_BADGES_FAILURE',

  REMOVE_BADGES: 'REMOVE_BADGES',
  REMOVE_BADGES_SUCCESS: 'REMOVE_BADGES_SUCCESS',
  REMOVE_BADGES_FAILURE: 'REMOVE_BADGES_FAILURE',

  RESTRICT_USER: 'RESTRICT_USER',
  RESTRICT_USER_SUCCESS: 'RESTRICT_USER_SUCCESS',
  RESTRICT_USER_FAILURE: 'RESTRICT_USER_FAILURE',

  REPORT_POST: 'REPORT_POST',
  REPORT_POST_SUCCESS: 'REPORT_POST_SUCCESS',
  REPORT_POST_FAILURE: 'REPORT_POST_FAILURE',

  LIKE_POST: 'LIKE_POST',
  LIKE_POST_SUCCESS: 'LIKE_POST_SUCCESS',
  LIKE_POST_FAILURE: 'LIKE_POST_FAILURE',

  FOLLOW_POST: 'FOLLOW_POST',
  FOLLOW_POST_SUCCESS: 'FOLLOW_POST_SUCCESS',
  FOLLOW_POST_FAILURE: 'FOLLOW_POST_FAILURE',

  UNFOLLOW_POST: 'UNFOLLOW_POST',
  UNFOLLOW_POST_SUCCESS: 'UNFOLLOW_POST_SUCCESS',
  UNFOLLOW_POST_FAILURE: 'UNFOLLOW_POST_FAILURE',

  REPLY_POST: 'REPLY_POST',
  REPLY_POST_SUCCESS: 'REPLY_POST_SUCCESS',
  REPLY_POST_FAILURE: 'REPLY_POST_FAILURE',

  UPDATE_POST_REPLY: 'UPDATE_POST_REPLY',
  UPDATE_POST_REPLY_SUCCESS: 'UPDATE_POST_REPLY_SUCCESS',
  UPDATE_POST_REPLY_FAILURE: 'UPDATE_POST_REPLY_FAILURE',

  SET_VISITOR_REPLY_DATA: 'SET_VISITOR_REPLY_DATA',
};



// WEBPACK FOOTER //
// ./src/modules/community/singlePost/actionTypes.js